
import './filterIdInput.css';
import React from 'react'

function FilterIdInput({placeholder, setItem}) {

    const changeHandler = (e) => {
        let inputValue = e.target.value;
        if (inputValue.trim() != "") {
            e.target.classList.add('has-value');
        } else {
            e.target.classList.remove('has-value');
        }
        setItem(inputValue.trim());
    }
    return (
        <div className="filter-id-input">
            <input type="text" onChange={(e)=>changeHandler(e)} />
            <label>{placeholder}</label>
        </div>
    )
}

export default FilterIdInput
